var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.field.before_html)}}),_c('div',{style:(_vm.field.style),domProps:{"innerHTML":_vm._s(_vm.field.html)}}),_c('div',{domProps:{"innerHTML":_vm._s(_vm.field.after_html)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }